
import sharePopup from './share-popup.js';

const twitterTakeaways = () => {
	var twitterTakeaways = document.querySelectorAll(".takeaways-list .tweetme-tldr");

	for (let i = 0; i < twitterTakeaways.length; i++) {

		twitterTakeaways[i].addEventListener('click', function (i, event) {
			event.preventDefault(event);

			const t = twitterTakeaways[i].innerText.trim();
			const u = document.querySelector('link[rel=canonical]').getAttribute('href');
			sharePopup('https://twitter.com/share?url=' + encodeURIComponent(u) + '&text=' + encodeURIComponent(t) + '');
			return false;
		}.bind(this, i));
	}
}

export default twitterTakeaways;